export const smartDocParamType_Static = 'static';
//# sourceMappingURL=types.js.map